import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { from, Observable, of, throwError } from 'rxjs';
import { environment } from '@environment';
import { AuthService } from './auth.service';
import { NavController } from '@ionic/angular';

@Injectable()
export class AuthRequestInterceptor implements HttpInterceptor {
  private currentRoute: string;
  private authRoute = '/auth/';
  private authLoginRoute = '/auth/login';
  private authLogoutRoute = '/auth/logout';
  private publicAssetPaths = ['./assets', 'assets'];

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private navCtrl: NavController,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    this.currentRoute = this.activatedRoute.snapshot['_routerState'].url;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return from(this.handle(req, next));
  }

  async handle(req: HttpRequest<any>, next: HttpHandler): Promise<any> {
    //FIXME just attach credentials to calls made to Nebulr APIs. Otherwise we expose credentials to other servers
    const [authToken, mfaToken, tenantUserId] = await Promise.all([this.authService.getAuthToken(), this.authService.getMfaToken(), this.authService.getTenantUserId()]);

    const url = this.getUrlWithoutParams();
    if (req.body?.operationName)
      console.log(req.body.operationName, req.body.variables, new Date());
    if (authToken) {
      req = req.clone({
        setHeaders: {
          'x-auth-token': mfaToken ? `${authToken}_${mfaToken}` : authToken,
        },
      });
    } else {
      // Requests missing authToken and made outside of the /auth route and open routes from environment should get to login screen
      if (!this.isPublicAsset(req.url)  && !this.isOpenRoute(url) && !url.startsWith(this.authRoute)) {
        console.log(
          `Request: to ${url} is missing authToken and made outside of the /auth route and open routes fron environment - going to login screen`
        );
        this.navCtrl.navigateRoot(this.authLogoutRoute);
        throw new Error("Request is missing authToken and made outside of the /auth route and open routes fron environment")
      }
    }
    if (tenantUserId) {
      req = req.clone({
        setHeaders: {
          'x-tenant-user-id': tenantUserId,
        },
      });
    }
    return next.handle(req).toPromise();
  }

  isOpenRoute(route: string): boolean {
    if (environment['openRoutes'].includes(route)) {
      return true;
    }

    if (route.startsWith('/welcome')) {
      const routeParts = route.split('/');
      if (routeParts.length === 3) {
        return this._validateTenantIdParam(routeParts[2]); // For /welcome/:tenantId case
      }
    }
    
    return false;
  }

  private _validateTenantIdParam(tenantId: string): boolean {
    if (tenantId.length !== 24) { // tenantId length should be 24 character long as 
      return false;
    }

    const regex = /^[0-9a-zA-Z]+$/; // tenantId should be alphanumeric
    return regex.test(tenantId);
  }

  isPublicAsset(url: string): boolean {
    return this.publicAssetPaths.filter(p => url.startsWith(p)).length > 0
  }

  private getUrlWithoutParams() {
    const urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams = {};
    return urlTree.toString();
  }

  private handleError(error: any): Observable<any> {
    console.log("Received request error", error);
    return throwError(error);
  }
}
